import { addressSchema } from 'platform/forms-system/src/js/web-component-patterns';
import {
  addressUI,
  DEFAULT_TITLE_OPTS,
  titleWithNameUI,
} from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['mailing-address--page-title'];
const DESC_TEXT = content['mailing-address--page-description'];

export default {
  uiSchema: {
    ...titleWithNameUI(TITLE_TEXT, DESC_TEXT, DEFAULT_TITLE_OPTS.applicant),
    applicantAddress: addressUI(),
  },
  schema: {
    type: 'object',
    required: ['applicantAddress'],
    properties: {
      applicantAddress: addressSchema(),
    },
  },
};
